import { routeCreator } from "../../../helpers/routing/routeCreator";
import projects from "../pages";
import Create from "../pages/create";
import Details from "../pages/details";
import Edit from "../pages/create";


export const ROUTE_PAGE_PROJECTS_INDEX = routeCreator(projects, '/projects', 'Projects', 'page.projects', {exact: true})
export const ROUTE_PAGE_PROJECT_CREATE = routeCreator(Create, '/project/create', 'Create', 'page.create', { exact: true })
export const ROUTE_PAGE_PROJECT_EDIT = routeCreator(Edit, '/project/edit/:projectId', 'Edit', 'page.edit')

export const ROUTE_PAGE_PROJECT_DETAILS = routeCreator(Details, '/project/details/:projectId', 'Details', 'page.details')

const router = {
    ROUTE_PAGE_PROJECTS_INDEX,
    ROUTE_PAGE_PROJECT_CREATE,
    ROUTE_PAGE_PROJECT_EDIT,
    ROUTE_PAGE_PROJECT_DETAILS
    
}

export default router